import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }

    const sessionId = match[1];
    // Clear hash immediately
    window.history.replaceState(null, '', window.location.pathname);

    exchangeSession(sessionId)
      .then(() => navigate('/', { replace: true }))
      .catch(() => navigate('/login?error=auth_failed', { replace: true }));
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-taxera-blue mx-auto mb-4" />
        <p className="text-sm text-slate-500">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
